<template>
  <v-dialog v-if="getInfoDialog.data != null" :value="getInfoDialog.isActive" @input="onClose" width="600">
    <v-card min-height="400">
      <v-card-title class="text-center">
        <v-spacer />
        <h1 class="title" v-html="item.title"></h1>
        <v-spacer />
        <v-btn icon @click="onClose()"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="grey--text">
        <template v-if="item.img">
          <v-img :src="require(`@/assets/media/${item.img}`)" :lazy-src="require(`@/assets/media/${item.img}`)"></v-img>
        </template>
        <!-- <p class="pt-10 mb-1">1. Visit your profile at Unsplash</p>
        <p class="mb-1">2. Cick on photo</p>
        <p class="mb-1">3. Copy the photo id</p> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    getInfoDialog() {
      return this.$store.getters.getInfoDialog
    },
    item() {
      return this.$store.getters.getInfoDialog.data
    },
  },
  methods: {
    onClose() {
      this.$store.dispatch('infoDialogAction', this.getInfoDialog.isActive)
    },
  },
}
</script>
